import { render } from "./pcmComponent.vue?vue&type=template&id=63a3cd68&scoped=true"
import script from "./pcmComponent.vue?vue&type=script&lang=js"
export * from "./pcmComponent.vue?vue&type=script&lang=js"

import "./pcmComponent.vue?vue&type=style&index=0&id=63a3cd68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a3cd68"]])

export default __exports__